// Paywall helpers (honor-system).
//
// Flow:
//   1. User clicks "Play Now" on the Landing page.
//   2. If the local `paidUntil` timestamp is in the future, they're let through.
//   3. Otherwise we redirect this tab to the Stripe Payment Link.
//   4. After a successful payment, Stripe redirects them back to
//      http://youbuzzedyet.com/?paid=1.
//   5. On app load `consumePaidQueryParam()` notices `?paid=1`, stores a 24h
//      `paidUntil` timestamp in localStorage, and strips the param from the URL.

// Use the live Stripe Payment Link on production (youbuzzedyet.com) and the
// test-mode link everywhere else (dev.youbuzzedyet.com, localhost, etc.) so
// dev testing doesn't run real cards.
const PROD_HOST = 'youbuzzedyet.com';

export const STRIPE_PAYMENT_LINK =
  typeof window !== 'undefined' && window.location.hostname === PROD_HOST
    ? 'https://buy.stripe.com/14AfZaaX221VgfeeoLasg01'
    : 'https://buy.stripe.com/test_dRm7sE4yE4a33ssdkHasg00';
const STORAGE_KEY = 'buzzed.paidUntil';
const ACCESS_DURATION_MS = 24 * 60 * 60 * 1000; // 24 hours

export function isPaid() {
  try {
    const raw = window.localStorage.getItem(STORAGE_KEY);
    if (!raw) return false;
    const until = parseInt(raw, 10);
    if (!Number.isFinite(until)) return false;
    return until > Date.now();
  } catch (e) {
    return false;
  }
}

export function grantAccess(durationMs = ACCESS_DURATION_MS) {
  try {
    window.localStorage.setItem(
      STORAGE_KEY,
      String(Date.now() + durationMs),
    );
  } catch (e) {
    // localStorage unavailable (private mode etc.) — paywall will re-trigger.
  }
}

// Called once at app startup. If the URL has `?paid=1`, grant access and
// remove the param so reloads don't keep re-granting.
export function consumePaidQueryParam() {
  try {
    const params = new URLSearchParams(window.location.search);
    if (params.get('paid') !== '1') return;
    grantAccess();
    params.delete('paid');
    const qs = params.toString();
    const newUrl =
      window.location.pathname + (qs ? '?' + qs : '') + window.location.hash;
    window.history.replaceState({}, '', newUrl);
  } catch (e) {
    // ignore
  }
}

export function redirectToCheckout() {
  window.location.href = STRIPE_PAYMENT_LINK;
}
